export const ROLE_EMPLOY_SUPER_ADMIN = 'SUPER_ADMIN';
export const ROLE_EMPLOY_ADMIN = 'ADMIN';
export const ROLE_EMPLOY_MERCHANT = 'MERCHANT_ADMIN';
export const ROLE_EMPLOY_MERCHANT_SUPER = 'MERCHANT_SUPER_ADMIN';
export const ROLE_EMPLOY_SECURITY = 'MERCHANT_SECURITY';
export const ROLE_CUSTOMER = 'CUSTOMER';

export const USER_ACTIVE_STATUS = 'ACTIVE';
export const USER_ACTIVE_INACTIVE = 'INACTIVE';
